import { useState, useEffect } from "react"; 
import axios from 'axiosInstance';
import './css/Eventos.css';
import { useNavigate } from "react-router-dom";
import { Row, Col, Card, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Spinner from 'react-bootstrap/Spinner';
import Carousel from 'react-bootstrap/Carousel';


function Eventos() {
  const [eventos, setEventos] = useState(null);
  const navegar = useNavigate();
  const [cargando, setCargando] = useState(true);

  const obtenerEventos = async () => {
    try {
      const respuesta = await axios.get(process.env.REACT_APP_BACKEND_URL + '/api/eventos');
      setEventos(respuesta.data);
      setCargando(false);
    } catch (error) {
      console.error(error);
    }
  };

  const eliminarEvento = async (id) => {
    try {
      await axios.delete(process.env.REACT_APP_BACKEND_URL + `/api/eventos/${id}`);
      setEventos(eventos.filter(evento => evento.evento_id !== id));
    } catch (error) {
      console.error("Error al eliminar el evento:", error);
    }
  };

  const editarEvento = (id) => {
    navegar(`/editarEvento/${id}`);
  };

  const crearEvento = () => {
    navegar(`/crearEvento`);
  };
   const detalleEvento = (id) => {
    navegar(`/detalleEvento/${id}`);
  };

  
  useEffect(() => {
    obtenerEventos();
  }, []); 

  return (
    
    
  <div className="contenedorEventos p-4">
    <div className=" justify-content-between align-items-center mb-4">
      <h1 class="tituloEventos m-3 ">EVENTOS</h1>
    </div>
    <div className="d-flex justify-content-between align-items-center mb-4">
      <Button className="boton_agregar" onClick={crearEvento}>Nuevo Evento</Button>
    </div>
{cargando ? (
        <div className="text-center my-5">
          <Spinner animation="grow" role="status" />
          <p className="mt-3">Cargando eventos...</p>
        </div>
      ) :
    eventos && eventos.length > 0 ? (
      <Row xs={1} md={2} lg={3} className="g-4">
        {eventos.map(evento => (
          <Col key={evento.evento_id}>
            <Card >
              
              <Card.Body class="tarjetaEvento">
                <Card.Title class="tituloEvento">{evento.nombre}</Card.Title>
                <Card.Text className="detalle-evento-texto text-center">
                  <div className="tipo-evento mb-2">
                    {evento.tipo_evento?.nombre}
                  </div>

                  <div className="periodo-inscripcion mb-3">
                    <strong>Periodo de Inscripción:</strong> {evento.estado_tipo?.nombre}
                  </div>

                  <div className="fechas-evento d-flex justify-content-center gap-5 mb-3">
                    <div>
                      <strong>Fecha Inicio:</strong><br />{evento.fecha_inicio}
                    </div>
                    <div>
                      <strong>Fecha Fin:</strong><br />{evento.fecha_fin}
                    </div>
                  </div>

                  <div className="creador-evento">
                    <strong>Creador:</strong> {evento.creador?.name}
                  </div>
                </Card.Text>

                <div className="d-flex justify-content-between mt-3">
                  <Button  className="boton_accion" size="sm" onClick={() => editarEvento(evento.evento_id)}>Editar</Button>
                 
                  <Button  className="boton_accion" size="sm" onClick={() => eliminarEvento(evento.evento_id)}>Eliminar</Button>
                </div>
              </Card.Body>
               <Button className="boton_detalles" size="sm" onClick={() => detalleEvento(evento.evento_id)}>Detalles</Button>
            </Card>
          </Col>
        ))}
      </Row>
    ) : (
      <p className=" text-center">
        no hay eventos 
      </p>
    )}
  </div>
);

}

export default Eventos;
